<template>
    <div class="custom-footer">

        <div class="footer-border">
            <div class="footer-item-code">
                <img  src="../assets/images/main/footer/wechat.png" class="code-img"/>
                <div>官方微信</div>
            </div>
            <div class="footer-item-code">
                <img  src="../assets/images/main/footer/sina.png" class="code-img"/>
                <div>官方微博</div>
            </div>
        </div>
        <div class="footer-center">
            <div class="footer-item-descript">
                <div>主办单位：威海市市场监督管理局</div>
                <div>办公电话：0631-5231616  地址：滨海南路49号</div>
                <div>网站标识码：3710000063 备案/许可证号：鲁ICP备05001812号</div>
                <div><img src="../assets/images/main/footer/huibiao.png" class="huibiao-img"/>鲁公网安备 37100402000418号</div>
            </div>
        </div>
        <div class="footer-right">
            <a href="https://bszs.conac.cn/sitename?method=show&id=93849A76A4239C3AE05310291AAC37F6"><img src="https://dcs.conac.cn/image/red.png"/></a>
        </div>

    </div>
</template>
<script>
    export default {
        name:'DefaultFooter',
        data(){
            return {}
        }
    }
</script>
<style scoped>
    .custom-footer {
        width:100%;
        max-width:1920px;
        min-width:1200px;
        /*min-width:1280px;*/
        color:#000000;
        background-color: #f2f2f2;
        height: 155px;
        display:flex;
        justify-content: center;
        align-items: center;
        text-align: center;
    }

    .footer-border{
        flex: 1;
        display:flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-left: 70px;

    }
    .footer-center{
        flex: 2;
        text-align: center;
    }
    .footer-right{
        flex: 1;
        display:flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding-right: 110px;
    }

    .footer-item-code {
        width:110px;
        font-size: 12px;
        line-height: 20px;
        height: 95px;
    }
    .code-img {
        width:55px;
        height:55px;
    }
    .huibiao-img{
        width:15px;
        height:15px;
    }
    .footer-item-descript {
        font-size:14px;
        line-height: 30px;
        text-align: center;
    }
    .flex-item{
        flex: 1;
    }

</style>